<template>
  <v-slide-y-transition mode="out-in">

    <v-container v-show="display" fluid grid-list-xl text-xs-center>
      <h1 v-if="!this.status.value" class="page-title display-1">Crear nuevo equipo</h1>
      <h1 v-else class="page-title display-1">Detalles del equipo</h1>
      <v-layout row justify-space-between  wrap>

        <v-flex xs12 sm12 md5 lg5 xl5>

          <vuetify-avatar-card
            :color="'primary'"
            :avatar="image || {}"
            :avatars="images || []"
            :controls="false"
            @on-upload-error="onUploadError"
            @on-change-avatar="onChangeAvatar"
          >
            <v-layout slot="card-title" column align-center justify-center>

              <v-layout :class="['column', 'avatar-info']" align-center justify-center>
                <vuetify-text-field
                  v-model="alias.value"
                  :item="alias"
                  @on-blur="onChange"
                  :validate.sync="alias.valid"
                ></vuetify-text-field>
              </v-layout>
            </v-layout>
            <visible-for superadmin administrator supervisor slot="card-text" v-if="status.value">
              <div slot="content">
                <v-tooltip top>
                  <v-btn
                    fab
                    dark
                    small
                    color="primary"
                    slot="activator"
                    @click.native="cloneDialog = true"
                  >
                    <v-icon>pages</v-icon>
                  </v-btn>
                  <span>Clonar equipo</span>
                </v-tooltip>
              </div>
            </visible-for>
          </vuetify-avatar-card>
          <vuetify-editable-form-card
            ref="characteristics"
            :color="'primary'"
            :toolbar-title="'Características'"
            :items="characteristics"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
        </v-flex>
        <v-flex xs12 sm12 md7 lg7 xl7>
          <vuetify-editable-form-card
            ref="equipment"
            :color="'primary'"
            :toolbar-title="'Equipo'"
            :items="equipment"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
          <vuetify-editable-form-card
            ref="installationType"
            :color="'primary'"
            :toolbar-title="'Instalación'"
            :items="installationType"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
        </v-flex>
            <v-btn
              v-if="!status.value"
              dark
              fab
              fixed
              bottom
              left
              color="primary"
              @click="returnToEquipments()"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-btn
              v-if="!status.value"
              dark
              fab
              fixed
              bottom
              right
              color="green"
              @click="validateEquipment()"
            >
              <v-icon>check</v-icon>
            </v-btn>


            <v-tooltip right>
              <v-btn
                v-if="!status.value"
                dark
                fab
                fixed
                bottom
                left
                color="primary"
                @click="returnToEquipments()"
              >
                <v-icon>arrow_back</v-icon>
              </v-btn>
              <span>Salir sin guardar</span>
            </v-tooltip>
            <v-tooltip left>
              <v-btn
                v-if="!status.value"
                dark
                fab
                fixed
                bottom
                right
                color="green"
                @click="validateEquipment()"
              >
                <v-icon>check</v-icon>
              </v-btn>
              <span>Guardar</span>
            </v-tooltip>
      </v-layout>


    <v-dialog persistent slot="extras" v-model="cloneDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">¿Duplicar equipo?</v-card-title>
        <v-card-text>
        Se va a crear un duplicado de este equipo: ¿desea continuar?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat="flat"
            @click="cloneDialog = false"
          >
            No
          </v-btn>

          <v-btn
            color="primary"
            flat="flat"
            @click="duplicateEquipment()"
          >
            Sí
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
  </v-slide-y-transition>

</template>

<script>
  import Rule from 'mixins/rule'
  import VisibleFor from '@/components/vue-user/visible-for'
  import VuetifyEditableFormCard from '@/components/vuetify-editable-form-card'
  import VuetifyTextField from '@/components/vuetify-form-creator/fields/vuetify-text-field'
  import VuetifyAvatarCard from '@/components/vuetify-avatar-card'

  export default {
    mixins: [Rule],

    components:
    {
      VisibleFor,
      VuetifyEditableFormCard,
      VuetifyAvatarCard,
      VuetifyTextField
    },

    data () {
      return {
        image: {},
        images: [],
        status: {},
        alias: {},
        installationType: [],
        characteristics: [],
        equipment: [],
        equipmentID: null,
        models: null,
        display: false,
        cloneDialog: false
      }
    },

    created () {
      this.getEquipment().then((response) => {
        // console.log(response)
        this.normalizeAndAssign(response.data)
        console.log('ssssddsss', this.image)
        let url = this.image.default
        this.image.src = this.image.value || this.image.default + '0.png'
        for (let i = 0; i < 2; i++) {
          this.images.push({ src: url + i + '.png' })
        }
        this.addRates()
        this.equipmentID = this.equipmentID.value
        this.models = this.equipment[2].items
        this.equipment[2].items = []
        this.normalizeModels(this.equipment[1])
        console.error(this.status)
        if (!this.isNew() && !this.status.value) {
          this.$awn.warning('Este equipo no existe.')
          return setTimeout(() => { this.$router.go(-1) }, 4000)
        }
        if (this.installationType[0].items.length > 0) {
          setTimeout(() => { this.display = true }, 100)
        } else {
          this.$awn.warning('Debes agregar al menos un tipo de instalación antes de poder crear equipos.')
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeAndAssign (params) {
        let filter = (param, def) => {
          return (typeof param !== 'undefined') ? param : def
        }
        params.map((obj, index) => {
          obj.label = filter(obj.label, undefined)
          obj.ref = filter(obj.ref, '')
          obj.order = filter(obj.order, '')
          obj.assign_to = filter(obj.assign_to, 'fields')
          obj.value_class = filter(obj.value_class, '')
          obj.tooltip = filter(obj.tooltip, 'Pulsa para editar')
          obj.focus_next_on_enter = filter(obj.focus_next_on_enter, true)
          obj.dark = filter(obj.dark, false)
          obj.color = filter(obj.color, 'primary')
          obj.columns = filter(obj.columns, 'xs12 sm6 md6 lg6')
          obj.counter = filter(obj.counter, false)
          obj.dialog = filter(obj.dialog, false)
          obj.editable = filter(obj.editable, false)
          obj.required = filter(obj.required, false)
          obj.disabled = filter(obj.disabled, false)
          obj.add_on_enter = filter(obj.add_on_enter, true)
          obj.type = filter(obj.type, 'select')
          obj.autocomplete = filter(obj.autocomplete, false)
          obj.rules = this.setRules(obj.rules)
          if (Array.isArray(this[obj.assign_to])) {
            this[obj.assign_to].push(obj)
          } else {
            this[obj.assign_to] = obj
          }
          return obj
        })
        return params
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeAvatar (item) {
        this.onChange(item.src, null, item, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onUploadError (type, requiredValue) {
        let errors = {
          'format': 'ERROR: La imagen debe tener un formato: ' + requiredValue,
          'max-file-size': 'ERROR: La imagen no debe superar los ' + (requiredValue / 1000) + 'kB',
          'width': 'ERROR: La imagen debe tener un ancho de ' + requiredValue + 'px',
          'height': 'ERROR: La imagen debe tener un alto de ' + requiredValue + 'px'
        }
        this.$awn.alert(errors[type])
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeStatus () {
        let status = parseInt(this.status.value) === 1 ? 2 : 1
        this.status.value = status
        this.onChange(this.status.value, null, this.status, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addRates () {
        let fields = [
          {
            assign_to: 'installationType',
            type: 'text-field',
            columns: 'xs4',
            label: 'Precio instalación (1)',
            disabled: true,
            editable: true,
            static_field: true,
            append_text: '€',
            value: ''
          },
          {
            assign_to: 'installationType',
            type: 'text-field',
            columns: 'xs4',
            label: 'Precio instalación (2)',
            disabled: true,
            editable: true,
            static_field: true,
            append_text: '€',
            value: ''
          },
          {
            assign_to: 'installationType',
            type: 'text-field',
            columns: 'xs4',
            label: 'Precio instalación (3)',
            disabled: true,
            editable: true,
            static_field: true,
            append_text: '€',
            value: ''
          },
          {
            assign_to: 'installationType',
            type: 'text-field',
            columns: 'xs12',
            label: 'Duración',
            disabled: true,
            editable: true,
            static_field: true,
            append_text: 'h',
            value: ''
          }
        ]
        this.normalizeAndAssign(fields)
        this.setRatesValues()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setRatesValues () {
        if (this.installationType[0].value) {
          this.installationType[1].value = this.installationType[0].value[this.installationType[0].item_text_2]
          this.installationType[2].value = this.installationType[0].value[this.installationType[0].item_text_3]
          this.installationType[3].value = this.installationType[0].value[this.installationType[0].item_text_4]
          this.installationType[4].value = this.installationType[0].value[this.installationType[0].item_text_5]
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isNew () {
        return this.$route.params.equipment_id === 'new'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onClickButton (item, isValid) {
        if (item.ref === 'submit-button' && isValid) {
          this.status.value = '1'
          this.$router.push(
            {
              name: 'equipment-id',
              params: {
                equipment_id: this.equipmentID
              }
            }
          )
          this.$forceUpdate()
        } else if (item.ref === 'cancel-button') {
          this.display = false
          this.$router.push(
            {
              name: 'equipments'
            }
          )
          this.deleteEquipment(this.equipmentID)
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      duplicateEquipment () {
        this.duplicateOnServer().then((id) => {
          if (id) {
            this.$router.push({
              name: 'equipment-id',
              params: {
                equipment_id: id
              }
            })
          }
        }).catch((error) => {
          console.log(error)
          this.$store.dispatch(
            'snackbar/show',
            'Error al duplicar reserva: ' + this.$store.getters['api/getMessage']
          )
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      duplicateOnServer () {
        return new Promise((resolve, reject) => {
          let equipmentID = this.$route.params.equipment_id
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'clone-equipment/' + equipmentID + '/'
          }).then((response) => {
            resolve(response.data || null)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener reservas: ' + this.$store.getters['api/getMessage']
            )
            reject(error)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteEquipment (equipmentID) {
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'equipment/' + equipmentID + '/'
        }).then((response) => {
          // console.log(response.data)
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Error al guardar: ' + this.$store.getters['api/getMessage'])
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getEquipment () {
        return new Promise((resolve, reject) => {
          let equipmentID = this.$route.params.equipment_id
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'equipment/' + equipmentID + '/'
          }).then((response) => {
            // console.log(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$awn.alert('Error al obtener el perfil: ' + this.$store.getters['api/getMessage'])
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChange (newVal, oldVal, item, isValid) {
        // console.log('········> ', newVal, oldVal)
        if (this.$store.getters['api/getStatus'] !== 'loading') {
          if (this.display && isValid && newVal !== oldVal) {
            item.value = newVal
            if (newVal && item.type === 'select') {
              this.updateItem(item, newVal[item.item_value])
            } else if ((item.type === 'text-field' || item.type === 'hidden' || item.type === 'image') && !item.static_field) {
              item.value = newVal
              this.updateItem(item, item.value)
            }
          }
        }
        if (item.brands_relations) {
          this.normalizeModels(item)
        }
        if (item.item_text_2 && item.item_text_3 && item.item_text_4) {
          this.setRatesValues()
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      validateEquipment () {
        let equipment = this.$refs.equipment.$refs.form_creator.validateForm()
        let characteristics = this.$refs.characteristics.$refs.form_creator.validateForm()
        let installationType = this.$refs.installationType.$refs.form_creator.validateForm()
        // console.log(equipment, characteristics, installationType)
        if (equipment && characteristics && installationType) {
          this.onChange('1', null, this.status, true)
          this.$router.push(
            {
              name: 'equipment-id',
              params: {
                equipment_id: this.equipmentID
              }
            }
          )
        } else {
          this.$awn.warning('Debes completar todos los campos requeridos')
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      returnToEquipments () {
        this.$router.push(
          {
            name: 'equipments'
          }
        )
        this.deleteEquipment(this.equipmentID)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeModels (item) {
        if (!item.value) {
          return false
        }
        let currentBrandID = item.value[item.item_value]

        if (item.brands_relations[currentBrandID]) {
          if (!this.models) {
            this.models = this.equipment[2].items
          }
          let brandModels = item.brands_relations[currentBrandID]

          let items = []
          this.models.forEach(obj => {
            let modelID = obj[this.equipment[2].item_value]

            if (brandModels.indexOf(modelID) > -1) {
              items.push(obj)
            }
          })

          let index = -1
          if (this.equipment[2].value && this.equipment[2].value[this.equipment[2].item_value]) {
            let id = this.equipment[2].value[this.equipment[2].item_value]
            index = items.findIndex(element => parseInt(element[this.equipment[2].item_value]) === parseInt(id))
          }

          this.equipment[2].items = items

          this.equipment[2].value = index > -1 ? items[index] : (items[0] || [])
        } else {
          this.equipment[2].items = []
          this.equipment[2].value = ''
        }
        // console.log('||||||||||||||', this.equipment[2].value)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddItem (newVal, oldVal, item, isValid) {
        let equipmentID = this.equipmentID
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'equipment/' + equipmentID + '/',
          data: {
            controller: item.item_controller,
            value: newVal
          }
        }).then((response) => {
          let value = {
            [item.item_text]: newVal,
            [item.item_value]: response.data
          }
          item.items.unshift(value)
          item.value = item.items[0]
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Al agregar nuevo elemento')
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateItem (item, value) {
        let equipmentID = this.equipmentID
        this.$store.dispatch('api/authRequest', {
          method: 'put',
          url: 'equipment/' + equipmentID + '/',
          data: {
            table: item.table,
            column: item.column,
            data_type: item.data_type,
            value: value
          }
        }).then((response) => {
          console.log(response)
          if (this.status.value && parseInt(this.status.value) < 3) {
            this.$awn.success('¡Hecho!')
          }
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Al actualizar')
        })
      }
    },

    watch: {
      'corporation.2.value': {
        handler: function (newVal, oldVal) {
          // console.log(newVal)
        },
        deep: true
      }
    }
  }
</script>

<style lang="sass">

.application
  background: rgba(63, 81, 181, 0.07058823529411765) !important

a
 text-decoration: none

.image 
  cursor: pointer

.flex
  /* padding: 5px 12px */

.container.grid-list-xl *:not(:only-child) .layout:first-child
  margin-top: 0px

.jst-card
  margin-bottom: 20px

.add-area

.carousel-actions
  padding: 18px

.carousel
  height: 250px
  width: 250px
  margin: 0 auto
  box-shadow: none

.input-file
  display: none

.image-info
  width: 72%

.add-address
  display: hidden

.address-autocomplete
  max-width: 435px
  margin: 0 auto
  padding: 32px 0 32px 0

.list-item
  display: inline-block
  margin-right: 10px

.list-enter-active, .list-leave-active
  transition: all 1s

.list-enter, .list-leave-to
  opacity: 0
  transform: translateY(30px)

html
  overflow-y: visible !important

.profile-options
  float: right
  bottom: 62px

.disable-area
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -ms-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;

.carousel-actions
  padding: 18px

.carousel
  height: 250px
  width: 250px
  margin: 0 auto
  box-shadow: none

.avatar-info
  width: 72%

</style>



// WEBPACK FOOTER //
// src/pages/equipment.vue